var exports = {
  "k": "xa15a2ab7--814119--container",
};

module.exports = exports;
